export default __webpack_public_path__ + "static/media/artist1.71906b81.jpg";